// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CheckboxLimitController from "./checkbox_limit_controller"
import DownloadAllController from "./download_all_controller"
import FileDropController from "./file_drop_controller"
import MenuToggleController from "./menu_toggle_controller"
import RevealController from "./reveal_controller"
import TabMemoryController from "./tab_memory_controller"

application.register("checkbox-limit", CheckboxLimitController)
application.register("download-all", DownloadAllController)
application.register("file-drop", FileDropController)
application.register("menu-toggle", MenuToggleController)
application.register("reveal", RevealController)
application.register("tab-memory", TabMemoryController)
